import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
// import Attachement from "./Attachement";
import Dasboard from "../../../../../../Components/Icons/Dasboard";
import * as yup from "yup";
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import axiosInstance from "../../../../../../Services/axiosCommon";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";



export default function EditMaterial({open, getData, onCancel, data,id,projectId,itemsCategory,Division,Unit,Item,Activity  }) {
  // console.log('====================================');
  // console.log(Item,"itemmm");
  // console.log('====================================');

   
  // const {value:Category ,getData:refMatrialCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialCategory')
  // const {value:Division ,getData:refMatrialDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialDivision')
  // const {value:Unit ,getData:refMaterialUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
  // const {value:Item ,getData:MatrialItem} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialItem')
    const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
   
    projectId:"",
    title_id:"",
    item:"",
    division:"",
    unit:"",
    quantity:"",
    amount:"",
    category:"",
    comments:""
  });
  useEffect(() => {
    data&&setCreateNew({
    item: data?.item || "",
    division: data?.division || "",
    unit: data?.unit || "",
    quantity: data?.quantity || "",
    amount: data?.amount || "",
    category: data?.category || "",
    comments: data?.comments    || "",
   
    })
  },[data])
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema:yup.object({
            item:yup.string().required("Item Name is Requried")
        }),
        onSubmit: (value,{resetForm}) => {
          axiosInstance.put(`/material/${data?.materialId}`, value)
          .then((res) => {
              console.log("res",res.data.status);
              if (res.data.status) {
                getData(id);
                resetForm();
                api.success({
                  message: `Manpower Item Update successfully`,
                  description: res?.data?.msg || "Added In The Activity",
                  placement: "bottomRight",
                });
                onCancel();
              } else {
                api.error({
                  message: `Manpower Item Upadate failed`,
                  description: res?.data?.msg || "Network error",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              api.error({
                message: `failed`,
                description: err?.data?.msg || "Sever error (or) Network error",
                placement: "bottomRight",
              });
            });
        },
      });
      useEffect(() => {
        const totalPrice = formik?.values?.actual_quantity * formik?.values?.actual_Price
        formik.setFieldValue("amount", totalPrice);
      }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
      // const { category: itemsCategory, subCategory: itemsSubCategory } =
      // UseCatSubCatDropDown(
      //   "/category/ItemCategory",
      //   "ItemCategory",
      //   formik?.values?.category
      // );
      return (
        <>
        {contextHolder}
        <Modal
          open={open}
          title={"Edit Material Item"}
          width={"50%"}
          className="my-modal"
          centered
          footer={[]}
          onCancel={onCancel}
        >
        <form onSubmit={formik.handleSubmit} >
          <div className=" w-full flex flex-wrap">
          
           <FormikSelectTwo
           
           label="Item"
           placeholder="Item"
           formik={formik}
           name="item"
          //  Option={Activity}
           isRequired={true}
           Options={Activity}
           width="w-full "               
            
       />
          <FormikSelectTwo
              // type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/2"
              // getFunc={getCategory}
              // categoryName={"MatrialCategory"}
              // displayProperty={"Add Category"}
              // isRequired={true}
            />
                <FormikSelectTwo
              label="Division"
              Options={Division}
              formik={formik}
              placeholder="Choose"
              name="division"
              width="w-full md:w-1/2"
          />
           <NuInput
                type="number"
                label=" Quantity"
                placeholder=" Quantity"
                formik={formik}
                name="quantity"
                width="w-full md:w-1/2"
              />
          <FormikSelectTwo
          label="Unit"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="unit"
          Options={Unit}
          />
              
            
              <NuInput
                type="number"
                label="Amount"
                placeholder="No of Days"
                formik={formik}
                name="amount"
                width="w-full md:w-1/2"
              />
            
             <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  width="w-full "
                />       <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                  <CancelButton handleClick={onCancel} />
                  <SubmitButton isLoading={isLoading} />
                </div>
          </div>
          </form>
        </Modal>
        </>
      )

}